import { Typography } from '@material-ui/core'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'
import './ConversionRateGraph.scss'

type Props = {
  conversionRate: number
  targetConversionRate: number
}

const Arrow = (props: {
  width: number
  midAngle: number
  cx: number
  outerRadius: number
  cy: number
}) => {
  const width = props.width || 220

  const RADIAN = Math.PI / 180
  const sin = Math.sin(-RADIAN * props.midAngle)
  const cos = Math.cos(-RADIAN * props.midAngle)
  const mx = props.cx + (props.outerRadius + width * 0.03) * cos
  const my = props.cy + (props.outerRadius + width * 0.03) * sin

  return (
    <g>
      <circle
        cx={props.cx}
        cy={props.cy}
        r={width * 0.025}
        fill="#666"
        stroke="none"
      />
      <path
        d={`M${props.cx},${props.cy}L${mx},${my}`}
        strokeWidth="4"
        stroke="green"
        fill="none"
        strokeLinecap="butt"
      />
    </g>
  )
}

export const ConversionRateGraph = (props: Props) => {
  const data = [
    { ...props },
    {
      conversionRate: 1 - props.conversionRate,
    },
  ]

  const targetConversionRate = props.targetConversionRate

  return (
    <>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            startAngle={180}
            endAngle={0}
            innerRadius="55%"
            data={data}
            dataKey="conversionRate"
          >
            <Cell fill="#8884d8" stroke="blue" />
            <Cell
              fill="#8884d8"
              fillOpacity={0.25}
              strokeDasharray={'12'}
              strokeWidth={2}
              stroke="blue"
            />
          </Pie>
          <Pie
            stroke="none"
            activeIndex={1}
            activeShape={Arrow}
            data={[
              { targetConversionRate: targetConversionRate },
              { targetConversionRate: 0 },
              { targetConversionRate: 1 - targetConversionRate },
            ]}
            dataKey={'targetConversionRate'}
            isAnimationActive={true}
            startAngle={180}
            endAngle={0}
            outerRadius="50%"
            fill="none"
          ></Pie>
          {/* <Tooltip content={ConversionRateTooltip} /> */}
          {/* <Legend content={ConversionRateLegend} /> */}
        </PieChart>
      </ResponsiveContainer>
      <div className="conversion-rate-legend">
        <div>
          <Typography variant="subtitle1">{`${(
            100 * props.conversionRate
          ).toFixed(0)}%`}</Typography>
          <LocalizedTypography
            translationKey={'common:dashboard-conversion-target'}
            variant="caption"
          />
        </div>
        <div>
          <Typography variant="subtitle1">
            {`${(100 * props.targetConversionRate).toFixed(0)}%`}
          </Typography>
          <LocalizedTypography
            translationKey={'common:dashboard-conversion-target'}
            variant="caption"
          />
        </div>
      </div>
    </>
  )
}
